import { injectable } from 'inversify';

import { getEnvironment } from '@shared/utils/env';
import config from './config.json';

interface AppConfig {
  apiURL: {
    origin: string;
    pathname: string;
  };
  apiSSO: {
    origin: string;
    pathname: string;
  };
  clientApiURL: {
    origin: string;
    pathname: string;
  };
  domain?: string;
  uploadFileSizeLimit?: number;
  logsPanelToken?: string;
  googleClientId?: string;
  appleClientId?: string;
  facebookClientId?: string;
}

@injectable()
export default class Config {
  static diToken = Symbol('config');

  private _appConfig!: AppConfig;

  initialize() {
    const env = getEnvironment();

    this._appConfig = env ? config[env] : config.Local;
  }

  get() {
    return this._appConfig;
  }
}
